import React, { useState } from "react";
import slasheye from "../../Assets/images/Eye Closed.png";
import eye from "../../Assets/images/Eye Closed.png";
import Vector from "../../Assets/images/logo.png";
import bgImage from "../../Assets/images/bg.jpg";
import toast from "react-hot-toast";
import { DELETE_ACCOUNT_API } from "../../API/ApiPage";

const DeleteAccounts = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(slasheye);
  const [isLoaded, setLoaded] = useState(false);

  const deleteAccount = (e) => {
    e.preventDefault();
    setLoaded(true);

    fetch(DELETE_ACCOUNT_API, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("response", data.message);
        if (data.status == 1) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
        setEmail("");
        setPassword("");
        setLoaded(false);
      })
      .catch((err) => {
        console.log(JSON.stringify("error", err));
        setLoaded(false);
      });
  };

  const show = () => {
    setType(type === "password" ? "text" : "password");
    setIcon(icon === slasheye ? eye : slasheye);
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      className="flex flex-col items-center justify-center min-h-screen p-5 m-0"
    >
      <div className="flex justify-center items-center">
        <img
          className="h-32 mx-1 rounded-2xl"
          src={Vector}
          alt="Your Company"
        />
      </div>

      <div className="w-full max-w-sm p-0 m-0 pt-5">
        <h2 className="my-5 text-center text-[30px] font-bold leading-9 ">
          Delete Account?
        </h2>
        <p className=" text-center text-[17px] leading-6">
          Are you sure you want to delete your account on Cups of love App?
        </p>
      </div>

      <div className="mt-10 w-full max-w-lg p-0 m-0">
        <form onSubmit={deleteAccount} className="space-y-5">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 "
            >
              Email
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email Address"
                autoComplete="off"
                required
                className="block w-full py-3 rounded-md border-0 pr-10 text-gray-900 shadow-sm ring-1 outline-0 px-3 ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-[#FF94A4] sm:leading-7"
              />
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 "
              >
                Password
              </label>
            </div>
            <div className="mt-2 relative">
              <input
                id="password"
                name="password"
                type={type}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                autoComplete="off"
                required
                className="block w-full py-3 rounded-md border-0 pr-10 text-gray-900 shadow-sm ring-1 outline-0 px-3 ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-[#FF94A4] sm:leading-7"
              />
              <button
                type="button"
                onClick={show}
                className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <img
                  src={icon}
                  width={17}
                  alt="password toggle"
                  className="eye-icon"
                />
              </button>
            </div>
          </div>

          <div className="mt-3">
            <button
              className="w-full rounded-md py-3 bg-[#C64755] px-5 text-base border-0 font-semibold leading-6 text-white shadow-sm mt-2 hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:leading-7 flex justify-center items-center"
              type="submit"
              disabled={isLoaded}
            >
              {isLoaded ? (
                <svg
                  className="animate-spin h-7 w-7 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
              ) : (
                "Delete Account"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteAccounts;
